// The older homepage blocks' carousels, tabs and sliders (snippets/orion-homepage-core.liquid). Until 2026-10-08 this was
// the snippet's {% javascript %}, which made Shopify send its whole snippet bundle (19 KB, mostly the catalogues' code)
// to every page before the first paint; now it comes as the theme's other scripts do (snippets/orion-script.liquid).
// The snippet may be printed more than once on a page, so the code runs once.
(() => {
  if (window.orionHomepageCore) return;
  window.orionHomepageCore = true;
  function createOrionProductCarousel(panel) {
    if (!panel) return null;
    if (panel.orionProductController) return panel.orionProductController;

    const slides = Array.from(panel.querySelectorAll('[data-orion-product-slide]'));
    const copies = Array.from(panel.querySelectorAll('[data-orion-product-copy]'));
    const dots = Array.from(panel.querySelectorAll('[data-orion-product-dot]'));
    const toggle = panel.querySelector('[data-orion-product-toggle]');
    const copiesContainer = panel.querySelector('[data-orion-product-copies]');
    if (!slides.length || slides.length !== copies.length) return null;

    const interval = Number(panel.dataset.interval) || 5000;
    const introStep = Number(panel.dataset.introStep) || 220;
    // The owner's rule: this motion plays also when the system asks for reduced motion.
    const reducedMotion = { matches: false };
    let activeIndex = 0;
    let introTimer;
    let autoplayTimer;
    let isActive = false;
    let isPaused = false;

    const clearTimers = function () {
      window.clearTimeout(introTimer);
      window.clearTimeout(autoplayTimer);
      introTimer = undefined;
      autoplayTimer = undefined;
    };

    const render = function (index) {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.classList.toggle('is-before', slideIndex < activeIndex);
        slide.setAttribute('aria-hidden', String(!active));
      });
      copies.forEach(function (copy, copyIndex) {
        const active = copyIndex === activeIndex;
        copy.classList.toggle('is-active', active);
        copy.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach(function (dot, dotIndex) {
        const active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
    };

    const scheduleNext = function () {
      window.clearTimeout(autoplayTimer);
      autoplayTimer = undefined;
      if (!isActive || isPaused || document.hidden || slides.length < 2) return;
      autoplayTimer = window.setTimeout(function () {
        if (copiesContainer) copiesContainer.setAttribute('aria-live', 'polite');
        render(activeIndex + 1);
        scheduleNext();
      }, interval);
    };

    const startIntro = function () {
      clearTimers();
      if (copiesContainer) copiesContainer.setAttribute('aria-live', 'off');
      render(0);
      if (!isActive || isPaused || document.hidden || slides.length < 2) return;
      if (reducedMotion.matches) {
        render(slides.length - 1);
        if (copiesContainer) copiesContainer.setAttribute('aria-live', 'polite');
        scheduleNext();
        return;
      }

      let nextIndex = 1;
      const advanceIntro = function () {
        if (!isActive || isPaused || document.hidden) return;
        if (nextIndex < slides.length) {
          render(nextIndex);
          nextIndex += 1;
          if (nextIndex < slides.length) {
            introTimer = window.setTimeout(advanceIntro, introStep);
          } else {
            if (copiesContainer) copiesContainer.setAttribute('aria-live', 'polite');
            scheduleNext();
          }
          return;
        }
        if (copiesContainer) copiesContainer.setAttribute('aria-live', 'polite');
        scheduleNext();
      };
      introTimer = window.setTimeout(advanceIntro, Math.max(280, introStep));
    };

    const setActive = function (active, restart) {
      isActive = active;
      clearTimers();
      if (!isActive || isPaused) return;
      if (restart) {
        startIntro();
      } else {
        scheduleNext();
      }
    };

    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () {
        clearTimers();
        if (copiesContainer) copiesContainer.setAttribute('aria-live', 'polite');
        render(dotIndex);
        scheduleNext();
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        isPaused = !isPaused;
        toggle.setAttribute('aria-pressed', String(isPaused));
        toggle.setAttribute('aria-label', isPaused ? 'Συνέχιση αυτόματης εναλλαγής' : 'Παύση αυτόματης εναλλαγής');
        if (isPaused) {
          clearTimers();
        } else {
          scheduleNext();
        }
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (!isActive || isPaused) return;
      if (document.hidden) {
        clearTimers();
      } else {
        scheduleNext();
      }
    });

    panel.orionProductController = {
      setActive: setActive,
      restart: startIntro
    };
    render(0);
    return panel.orionProductController;
  }

  function initializeOrionCollectionTabs(container) {
    if (!container || container.dataset.orionCollectionReady === 'true') return;

    const tabs = Array.from(container.querySelectorAll('[data-orion-collection-tab]'));
    const panels = Array.from(container.querySelectorAll('[data-orion-collection-panel]'));
    if (!tabs.length || tabs.length !== panels.length) return;

    const carousels = panels.map(createOrionProductCarousel);
    let activeIndex = 0;
    let sectionVisible = false;

    const updateCarousels = function (restart) {
      carousels.forEach(function (carousel, carouselIndex) {
        if (!carousel) return;
        carousel.setActive(sectionVisible && carouselIndex === activeIndex, restart && carouselIndex === activeIndex);
      });
    };

    const activate = function (index, moveFocus, restartCarousel) {
      activeIndex = (index + tabs.length) % tabs.length;
      tabs.forEach(function (tab, tabIndex) {
        const isActive = tabIndex === activeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });
      panels.forEach(function (panel, panelIndex) {
        const isActive = panelIndex === activeIndex;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
      });
      updateCarousels(restartCarousel);
      if (moveFocus) tabs[activeIndex].focus();
    };

    tabs.forEach(function (tab, tabIndex) {
      tab.addEventListener('click', function () {
        activate(tabIndex, false, true);
      });
      tab.addEventListener('keydown', function (event) {
        let targetIndex;
        if (event.key === 'ArrowRight') targetIndex = activeIndex + 1;
        if (event.key === 'ArrowLeft') targetIndex = activeIndex - 1;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = tabs.length - 1;
        if (targetIndex === undefined) return;
        event.preventDefault();
        activate(targetIndex, true, true);
      });
    });

    container.dataset.orionCollectionReady = 'true';
    activate(activeIndex, false, false);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          const wasVisible = sectionVisible;
          sectionVisible = entry.isIntersecting;
          updateCarousels(sectionVisible && !wasVisible);
        });
      }, { threshold: .2 });
      observer.observe(container);
    } else {
      sectionVisible = true;
      updateCarousels(true);
    }
  }

  function initializeOrionProductionSlider(slider) {
    if (!slider || slider.dataset.orionProductionReady === 'true') return;

    const tabs = Array.from(slider.querySelectorAll('[data-orion-production-tab]'));
    const panels = Array.from(slider.querySelectorAll('[data-orion-production-panel]'));
    const copyPanels = Array.from(slider.querySelectorAll('[data-orion-production-copy-panel]'));
    if (panels.length < 2 || tabs.length < panels.length) return;

    const interval = Number(slider.dataset.interval) || 10000;
    // The owner's rule: this motion plays also when the system asks for reduced motion.
    const reducedMotion = { matches: false };
    let activeIndex = 0;
    let timer;

    const stop = function () {
      window.clearTimeout(timer);
      timer = undefined;
      tabs.forEach(function (tab) {
        tab.classList.remove('is-progressing');
      });
    };

    const activate = function (index) {
      activeIndex = (index + panels.length) % panels.length;
      tabs.forEach(function (tab) {
        const tabIndex = Number(tab.dataset.orionProductionTab) - 1;
        const isActive = tabIndex === activeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
      });
      panels.forEach(function (panel, panelIndex) {
        const isActive = panelIndex === activeIndex;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
      });
      copyPanels.forEach(function (panel) {
        const panelIndex = Number(panel.dataset.orionProductionCopyPanel) - 1;
        const isActive = panelIndex === activeIndex;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
      });
    };

    const play = function () {
      stop();
      if (reducedMotion.matches || document.hidden) return;
      slider.style.setProperty('--orion-production-duration', interval + 'ms');
      tabs.forEach(function (tab) {
        if (Number(tab.dataset.orionProductionTab) - 1 !== activeIndex) return;
        void tab.offsetWidth;
        tab.classList.add('is-progressing');
      });
      timer = window.setTimeout(function () {
        activate(activeIndex + 1);
        play();
      }, interval);
    };

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(Number(tab.dataset.orionProductionTab) - 1);
        play();
      });
      tab.addEventListener('keydown', function (event) {
        let targetIndex;
        if (event.key === 'ArrowRight') targetIndex = activeIndex + 1;
        if (event.key === 'ArrowLeft') targetIndex = activeIndex - 1;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = tabs.length - 1;
        if (targetIndex === undefined) return;
        event.preventDefault();
        activate(targetIndex);
        const matchingTab = tabs.find(function (candidate) {
          return Number(candidate.dataset.orionProductionTab) - 1 === activeIndex && candidate.offsetParent !== null;
        });
        if (matchingTab) matchingTab.focus();
        play();
      });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else play();
    });

    slider.dataset.orionProductionReady = 'true';
    activate(activeIndex);
    play();
  }

  function initializeOrionDiaryCarousel(carousel) {
    if (!carousel || carousel.dataset.orionDiaryReady === 'true') return;

    const track = carousel.querySelector('[data-orion-diary-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-orion-diary-slide]'));
    const nextButton = carousel.querySelector('[data-orion-diary-next]');
    if (!track || slides.length < 2 || !nextButton) return;

    // The owner's rule: this motion plays also when the system asks for reduced motion.
    const reducedMotion = { matches: false };

    const getActiveIndex = function () {
      const trackStyles = window.getComputedStyle(track);
      const trackStart = track.getBoundingClientRect().left + parseFloat(trackStyles.paddingLeft || 0);
      return slides.reduce(function (closestIndex, slide, slideIndex) {
        const closestDistance = Math.abs(slides[closestIndex].getBoundingClientRect().left - trackStart);
        const slideDistance = Math.abs(slide.getBoundingClientRect().left - trackStart);
        return slideDistance < closestDistance ? slideIndex : closestIndex;
      }, 0);
    };

    nextButton.addEventListener('click', function () {
      const nextIndex = (getActiveIndex() + 1) % slides.length;
      slides[nextIndex].scrollIntoView({
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    });

    carousel.dataset.orionDiaryReady = 'true';
  }

  document.querySelectorAll('[data-orion-collection-tabs]').forEach(initializeOrionCollectionTabs);
  document.querySelectorAll('[data-orion-production-slider]').forEach(initializeOrionProductionSlider);
  document.querySelectorAll('[data-orion-diary-carousel]').forEach(initializeOrionDiaryCarousel);
  document.addEventListener('shopify:section:load', function (event) {
    initializeOrionCollectionTabs(event.target.querySelector('[data-orion-collection-tabs]'));
    initializeOrionProductionSlider(event.target.querySelector('[data-orion-production-slider]'));
    initializeOrionDiaryCarousel(event.target.querySelector('[data-orion-diary-carousel]'));
  });

})();
